import { render, staticRenderFns } from "./TipolugarModalNuevo.vue?vue&type=template&id=74849252&scoped=true&"
import script from "./TipolugarModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./TipolugarModalNuevo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74849252",
  null
  
)

export default component.exports